export default class LicenseProvider
{
    ProvideLicense()
    {
        return {
            company: "Dun & Bradstreet Hungary Kft.",
            date: "01/09/2026",
            developer: "László Meidl (meidll@dnb.com)",
            distribution: true,
            domains: ["bisnode.hu"],
            fileSystemAllowed: false,
            licensefileversion: "1.1",
            localhost: false,
            oobAllowed: false,
            package: "complete",
            product: "yFiles for HTML",
            subscription: "12/19/2026",
            type: "singledeveloper",
            version: "3.0",
            key: "3034821a64303b0fcb707db71053bbfb2be9fb24"
          };
    }
}